import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./plugins"

import './assets/styles/_main.scss'

import LottieAnimation from 'lottie-vuejs'

Vue.config.productionTip = false

Vue.filter('currency', value => {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
})

Vue.use(LottieAnimation)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
